var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"w-100"},[_c('el-date-picker',_vm._b({attrs:{"picker-options":_vm.pickerOptions},on:{"change":_vm.changeRange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-date-picker',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }